import React, { useState } from 'react'
import { Link } from "react-router-dom"
import { useDispatch } from 'react-redux'

//--- layouts & components ---
import LoginLayout from '../../layout/LoginLayout'
import LeftImageComponent from '../../components/CommonComponents/LeftImageComponent'
import Image from '../../assets/img/signin.png'
import {AiOutlineMail } from 'react-icons/ai'
import {RiErrorWarningLine } from 'react-icons/ri'
import { emailValidator } from '../../utils/validator'
import { doForgotPassword } from '../../redux/actions/auth'

const ForgotPassword = () => {
    const dispatch = useDispatch()
    const [emailValues, setEmail] = useState({
      email : '',
      error : ''
    })

    const onResetPassword = () => {
      if (!emailValues.email) {
        emailValues.error = 'Email should not be empty!'
      } else {
        if (!emailValidator(emailValues.email)) {
          emailValues.error = 'This email is invalid'
        } else {
          emailValues.error = ''
        }
      }
        
      if (emailValues.error === '') {
        dispatch(doForgotPassword({
          email: emailValues.email,
        })).then(() => {
          setEmail({...emailValues, email:''})
        }).catch((err) => {
          console.log(err.response.data)
        })
      } else {
        setEmail({...emailValues})
      }
    }

    const handleEmailChange = (event) => {
      if (emailValues.email) {
        if (!emailValidator(emailValues.email)) {
          emailValues.error = 'This email is invalid'
        } else {
          emailValues.error = ''
        }
      }
      setEmail({...emailValues, email : event.target.value})
    }

  return (
    <LoginLayout>
      <div className="forgot-password-page flex-sm-column flex-column flex-lg-row">
        <div className='forgot-password-left'>
          <LeftImageComponent image={Image} quote="A User Friendly Software with Exceptional Customer Support" quoteby="-Kristi H, Denver, US"/>
        </div>
        <div className={`forgot-password-right `}>
            <div className="form-content">
                <div className="form-title">
                  <h4>Forgot Password?</h4>
                  <span>We will help you reset it and get back on track.</span>
                </div>
                <div className="form-input-container">
                  <div className={`form-input-inner ${emailValues.error ? '' : 'has-bottom-margin'}`}>
                    <div className="form-input">
                      <input className={`${emailValues.error ? 'error-border' : ''}`} type="text" placeholder="Email Address" value={emailValues.email} onChange={handleEmailChange}/>
                      <AiOutlineMail color="#104569" size={24} />
                    </div>
                    {emailValues.error && (
                      <div className='error-container flex align-center'>
                        <RiErrorWarningLine className='mb-2' color="#F75A52" size={15} />
                        <p className='error mb-2'>{emailValues.error}</p>
                      </div>
                    )}
                  </div>
                  
                  <button type="button" className="btn-login" onClick={onResetPassword}>Reset Password</button>
                  <Link to="/login" className='back-to-login'>Back to login</Link>
                </div>
            </div>
          <div className='privacy-copyright-container d-flex justify-content-between h-100 w-100 align-items-end'>
            <span className='h3'> Privacy Policy </span>
            <span className='h3'> Copyright 2022 </span>
          </div>
        </div>
      </div>
    </LoginLayout>
  )
}

export default ForgotPassword
